export const boardCorrespondenceTour = {
  key: "boardCorrespondence",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="board-correspondence-add"]',
      content: t("Tour_BoardCorrespondence_Add"),
      placement: "top",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-correspondence-categories"]',
      content: t("Tour_BoardCorrespondence_Categories"),
      placement: "top",
    },
    {
      target: '[data-tour="board-correspondence-attachments"]',
      content: t("Tour_BoardCorrespondence_Attachments"),
      placement: "top",
    },
  ],
};
